/* eslint-disable no-unused-vars */
import React from "react";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
// import TableSortLabel from "@material-ui/core/TableSortLabel";

import {
  FormattedDate,
  FormattedMessage,
  FormattedTime,
  // useIntl,
} from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // minWidth: 500,
      height: "100%",
    },
  })
);

interface EventTableProps {
  // // nodes: any[];
  // chartData: any[];
  // allData: DataSeries[]; // series options (except yaxes?) => TODO allData must be included in metaData.options
  // // data: any[];
  // metaData: MetaData; // general plot options
  // dataSeries: DataSeries[]; // actual data
  // widgetStatic?: boolean;
  // widgetTitle?: string;

  dataSource: { [key: string]: any }[];
  // changeVariables: any;
  loading: boolean;
  totalElements?: number;

  // TODO probably this belongs to the container!
  createEntityMutation?: any;
  updateEntityMutation?: any;
  deleteEntityMutation?: any;

  // TODO naming! (e.g., onViewClick, onEditClick, onDeleteClick)
  onView: any;
  onEdit: any;
  onDelete: any;

  sorting: any;
  onSortingChange: any;
  expandedRowIds: any;
  onExpandedRowIdsChange: any;
  currentPage: any;
  onCurrentPageChange: any;
  pageSize: any;
  onPageSizeChange: any;
  hiddenColumnNames: any;
  onHiddenColumnNamesChange: any;
}

function EventTableMui(props: EventTableProps) {
  const classes = useStyles(props);
  // const { match, location } = props;
  // const { nodes, startDate, endDate } = props;
  const {
    dataSource = [],
    // changeVariables,
    // loading,
    totalElements,
    // createEntityMutation,
    // updateEntityMutation,
    // deleteEntityMutation,
    // onView,
    // onEdit,
    // onDelete,

    // sorting,
    // onSortingChange,
    // expandedRowIds,
    // onExpandedRowIdsChange,
    currentPage,
    onCurrentPageChange,
    pageSize,
    onPageSizeChange,
    // hiddenColumnNames,
    // onHiddenColumnNamesChange,
  } = props;
  // const intl = useIntl();

  const page = currentPage;
  const rowsPerPage = pageSize;

  // const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    // setPage(newPage);
    onCurrentPageChange(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    // setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
    onPageSizeChange(parseInt(event.target.value, 10));
  };
  let rows = dataSource
    ? dataSource
        .map((content: any) => {
          // TODO const parameters = _.mapValues(_.keyBy(content.parameters, 'idx'), 'value')
          // const parameters = _.mapValues(
          //   _.keyBy(
          //     content.parameters
          //       .map((p: any, index: number) => ({ ...p, idx: index }))
          //       .map((p: any) => {
          //         const { stringRepresentation } = p;
          //         let newStringRepresentation = stringRepresentation;
          //         if (stringRepresentation && stringRepresentation.startsWith('i18n')) {
          //           const subString =  stringRepresentation.substring(5, stringRepresentation.length - 1);
          //           const messageDescriptor = addvantageMessages['addvantage.' + subString];
          //           if (messageDescriptor) {
          //             newStringRepresentation = intl.formatMessage(
          //               messageDescriptor,
          //               // parameters
          //             );
          //           } else {
          //             console.error(`Could not find messageDescriptor for i18n '${subString}'`)
          //           }
          //         }
          //         return ({ ...p, stringRepresentation: newStringRepresentation/*, idx: index*/ });
          //       }),
          //     'idx'
          //   ),
          //   // 'value'
          //   'stringRepresentation'
          // );
          // // console.log('Template: ', content.template);
          // // console.log('Template parameters: ', parameters);
          // // TODO eventType or eventMessage?
          // const messageDescriptor = addvantageMessages['addvantage.' + content.template + '.eventMessage'];
          // if (!messageDescriptor) {
          //   console.error("Could not find messageDescriptor for template " + content.template)
          // }
          // const message = messageDescriptor ? intl.formatMessage(
          //   messageDescriptor,
          //   parameters
          // ) : content.template;
          // // const message = content.template;
          return {
            ...content,
            ...content.interval,
            // sourceNode: content.sourceNode ? content.sourceNode.name : '',
            // area: content.area ? content.area.name : '',
            message: content.formatted,
            duration: content.durationFormatted,
          };
        })
        .sort(
          (a: any, b: any) =>
            new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
        ) // TODO remove sorting (should be done on server)
    : [];

  const columns = [
    // { name: "command", label: " " },
    // { name: "id", label: "Id" },

    {
      id: "startDate",
      label: "Begin Date",
      width: 200,
      format: ({ value }: any) => (
        <>
          {/* TODO Use row.sourceNode.timeZoneID for formatting! */}
          <FormattedDate
            value={value}
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
          &nbsp;
          <FormattedTime value={value} />
        </>
      ),
    },
    // { id: "endDate", label: "End Date" },
    {
      id: "duration",
      label: "Duration",
      format: ({ value, row }: any) => (
        <>
          {row.interval.endDate === null ? (
            <FormattedMessage
              id="addvantage.common.event.active"
              defaultMessage={"- active -"}
            />
          ) : (
            value
          )}
        </>
      ),
    },
    {
      id: "sourceNode",
      label: "Source",
      format: ({ value }: any) => (
        <span title={value.fullPath}>
          {value.name} ({value.id})
        </span>
      ),
    },
    // { id: 'area', label: 'Area' },
    { id: "message", label: "Message", width: 800 },
    // { id: 'template', label: 'template' },
    // { id: 'parameters', label: 'parameters' },
  ];

  const totalCount = totalElements ? totalElements : rows ? rows.length : 0; // TODO improve this!

  // const page = /*(data.dataPoints && data.dataPoints.page) ||*/ {
  //   __typename: "Page",
  //   size: rows.length, // pageSize,
  //   totalElements: 0,
  //   totalPages: 0,
  //   number: currentPage,
  // };
  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <TableContainer className={classes.container}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                // align={column.align}
                style={{ minWidth: column.width }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No data
              </TableCell>
            </TableRow>
          )}
          {rows.map((row) => (
            <TableRow key={row.id}>
              {columns.map((column) => {
                const value = row[column.id];
                return (
                  <TableCell
                    key={column.id}
                    // align={column.align}
                    style={{ minWidth: column.width }}
                  >
                    {column.format ? column.format({ value, row }) : value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
          {/* {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={columns.length} />
            </TableRow>
          )} */}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                // , { label: 'All', value: -1 }
              ]}
              colSpan={columns.length}
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              // ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}

export default EventTableMui;
